import { cn } from "@/lib/utils";

const statusStyles: Record<string, string> = {
  pass: "bg-emerald-500/10 text-emerald-500 border-emerald-500/20",
  completed: "bg-emerald-500/10 text-emerald-500 border-emerald-500/20",
  fail: "bg-rose-500/10 text-rose-500 border-rose-500/20",
  failed: "bg-rose-500/10 text-rose-500 border-rose-500/20",
  error: "bg-rose-500/10 text-rose-500 border-rose-500/20",
  skip: "bg-muted text-muted-foreground border-border",
  // Known-issue vocabulary: xfail = expected fail (quiet), xpass = an
  // expected failure that PASSED — loud cyan, the ticket may be closable.
  xfail: "bg-yellow-500/10 text-yellow-600 border-yellow-500/20",
  xpass: "bg-cyan-500/10 text-cyan-500 border-cyan-500/20",
  in_progress: "bg-amber-500/10 text-amber-500 border-amber-500/20",
  // Timed-out runs are an error state distinct from `failed` — the runner
  // stopped reporting heartbeats, so test outcomes are unknown rather than
  // explicitly bad. Slate-blue keeps it visually separate from rose `failed`.
  timed_out: "bg-slate-500/10 text-slate-400 border-slate-500/20",
};

const statusLabels: Record<string, string> = {
  timed_out: "timed out",
};

export function CiStatusBadge({ status }: { status: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium",
        statusStyles[status] ?? "bg-muted text-muted-foreground border-border",
      )}
    >
      {statusLabels[status] ?? status.replace("_", " ")}
    </span>
  );
}
